import { useLazyQuery } from '@apollo/client';
import { ALL_MODULES, Loader } from '@nile/components';
import { GET_FIELD, AccountClient } from '@nile/graphql';
import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';
import { Button, ButtonGroup } from '@shopify/polaris';
import { Checkbox, Popover } from '@superops/ui-design-system';
import { Edit } from '@styled-icons/material/Edit';
import { cloneDeep, isEqual } from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
const CustomField = styled.div`
  min-width: 200px;
  max-width: 250px;
  flex-grow: 1;
  padding-right: 10px;
  padding-left: 10px;
  margin-top: 8px;
  margin-bottom: 8px;
  .Polaris-ButtonGroup {
    margin-top: 12px;
  }
`;
const Label = styled.div`
  text-align: left;
  font-weight: 500 !important;
  color: rgba(0, 0, 0, 0.6);
  margin-top: 10px;
`;
const Wrap = styled.div`
  display: flex;
  align-items: center;
  .edit-actions {
    visibility: hidden;
    cursor: pointer;
  }
  padding-left: 8px;
  padding-right: 8px;
  max-width: 100%;
`;
const EditIcon = styled(Edit)`
  color: black;
  height: 16px;
  width: 16px;
  margin-left: 6px;
  margin-right: 6px;
`;
const CField = styled.div`
  .editable-cell,
  .cell {
    flex-grow: 1;
    font-weight: bold;
  }
  &:hover {
    .edit-actions {
      visibility: visible;
    }
  }
`;
function AsyncCheckboxNew(props) {
  const {
    field,
    ticket,
    defaultValue,
    updateSelection,
    editable,
    value,
    inlineEdit,
    disableSelection,
    isMandatory
  } = props;
  const [getFieldData, { called, loading, data }] = useLazyQuery(GET_FIELD, {
    client: AccountClient,
    fetchPolicy: 'cache-and-network',
    variables: {
      input: {
        columnName: field.columnName || field.name,
        module: props.module || ALL_MODULES.ticket
      }
    }
  });
  const [selectedItems, setSelectedItems] = useState(value || []);
  const [popoverActive, setPopoverActive] = useState(false);
  const togglePopoverActive = useCallback(() => {
    getFieldData();
    setPopoverActive(!popoverActive);
  });
  const [updatedValue, setUpdatedValue] = useState(value || []);
  const purgeEmptyStrings = (arr) => {
    if (arr) {
      const clonedArr = cloneDeep(arr);
      arr.filter((val, i) => {
        if (val === '') {
          clonedArr.splice(i, 1);
        }
      });
      return clonedArr;
    }
    return [];
  };
  useEffect(() => {
    if (!isEqual(updatedValue, value)) {
      if (!value) {
        setUpdatedValue([]);
      } else {
        setUpdatedValue(value);
      }
    }
  }, [value]);
  const updateUpdatedValue = (checked, newValue) => {
    const allValues = purgeEmptyStrings(cloneDeep(updatedValue));
    if (!checked) {
      const index = allValues.indexOf(newValue);
      allValues.splice(index, 1);
      if (allValues.length) {
        setUpdatedValue(allValues);
      } else {
        setUpdatedValue(null);
      }
    } else {
      allValues.push(newValue);
      setUpdatedValue(allValues);
    }
  };
  const updateSelectedField = (checked, newValue) => {
    const allValues = purgeEmptyStrings(cloneDeep(selectedItems));
    if (!checked) {
      const index = allValues.indexOf(newValue);
      allValues.splice(index, 1);
      if (allValues.length) {
        setSelectedItems(allValues);
      } else {
        setSelectedItems(null);
      }
    } else {
      allValues.push(newValue);
      setSelectedItems(allValues);
    }
    if (allValues.length) {
      updateSelection(allValues);
    } else {
      updateSelection(null);
    }
  };
  const displayVal = value;
  const activator = <EditIcon onClick={() => togglePopoverActive()} />;
  const fieldOptions =
    data?.getField?.options || data?.getField?.fieldOptions || [];
  const LoadingStyles = styled.div`
    padding: 40px;
  `;
  const getTag = () => {
    if (loading) {
      return (
        <LoadingStyles>
          <Loader />
        </LoadingStyles>
      );
    }
    return (
      <CustomField className="cf-wrapper">
        <Label className="cf-label">
          {field.label || ''}{' '}
          {isMandatory && (
            <>
              <span className="mandatory-star">*</span>
            </>
          )}
        </Label>
        <div
          className={`flex col ${props.error ? 'cf-error-state' : ''}`}
          key={field.name}
        >
          {fieldOptions?.map((item) => {
            return (
              <Checkbox
                label={item.value}
                id={`checkbox-${item.value}-${field.columnName || field.name}`}
                name={`checkbox-${item.value}-${field.columnName ||
                  field.name}`}
                checked={updatedValue?.indexOf(item.value) > -1}
                onChange={(checked) => updateUpdatedValue(checked, item.value)}
                disabled={disableSelection}
              />
            );
          })}
        </div>
        <ButtonGroup className="mt10">
          <Button
            onClick={() => {
              togglePopoverActive();
              setUpdatedValue(value || []);
            }}
          >
            Cancel
          </Button>
          <Button
            primary
            onClick={() => {
              updateSelection(updatedValue);
              togglePopoverActive();
            }}
          >
            Save
          </Button>
        </ButtonGroup>
      </CustomField>
    );
  };
  if (inlineEdit) {
    return !popoverActive ? (
      <CField className="fw">
        <Wrap className={`${editable ? 'editable-cell' : 'cell'}`}>
          <div className="ellipsis" title={displayVal}>
            {displayVal?.length ? (
              displayVal.join(',')
            ) : (
              <DisabledTag>NA</DisabledTag>
            )}
          </div>
          {editable && <div className="edit-actions">{activator}</div>}
        </Wrap>
      </CField>
    ) : (
      <CField className="fw">
        <Wrap className="editable-cell">
          <div className="ellipsis" title={displayVal}>
            {displayVal?.length ? (
              displayVal.join(',')
            ) : (
              <DisabledTag>NA</DisabledTag>
            )}
          </div>
          <Popover
            activator={activator}
            active={popoverActive}
            onClose={() => {
              // togglePopoverActive()
            }}
          >
            {getTag()}
          </Popover>
        </Wrap>
      </CField>
    );
  }
  return (
    <CustomField className="cf-wrapper">
      <Label className="cf-label">
        {field.label || ''}
        {isMandatory && (
          <>
            <span className="mandatory-star">*</span>
          </>
        )}
      </Label>
      <div
        className={`flex col ${props.error ? 'cf-error-state' : ''}`}
        key={field.name}
      >
        {fieldOptions?.map((item) => {
          return (
            <Checkbox
              label={item.value}
              id={`checkbox-${item.value}-${data?.getField.columnName}`}
              name={`checkbox-${item.value}-${data?.getField.columnName}`}
              checked={selectedItems?.indexOf(item.value) > -1}
              onChange={(checked) => updateSelectedField(checked, item.value)}
              disabled={disableSelection}
            />
          );
        })}
      </div>
    </CustomField>
  );
}
export default AsyncCheckboxNew;
